var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconPbhsWebsiteAdminPortal = function SvgIconPbhsWebsiteAdminPortal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83333 1.875H21.0833V0H3.83333C2.77917 0 1.91667 0.84375 1.91667 1.875V12.1875H0V15H13.4167V12.1875H3.83333V1.875ZM22.0417 3.75H16.2917C15.7646 3.75 15.3333 4.17188 15.3333 4.6875V14.0625C15.3333 14.5781 15.7646 15 16.2917 15H22.0417C22.5688 15 23 14.5781 23 14.0625V4.6875C23 4.17188 22.5688 3.75 22.0417 3.75ZM21.0833 12.1875H17.25V5.625H21.0833V12.1875Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconPbhsWebsiteAdminPortal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-pbhs-website-admin-portal.2ef5d6b45f6906566a26aab3482cfc15.svg";